import { Box, Button, Container, styled, Typography } from "@mui/material";
import { textTransform } from "@mui/system";
import React from "react";
import LatestProduct from "./Product";
import prod1 from "../assets/images/products/prod1.webp";
import prod1_2 from "../assets/images/products/prod1_2.webp";
import SouthIcon from "@mui/icons-material/South";
import { useGetLimitProductsQuery } from "../services/queries";
import { ChangeProductGridDisplay } from "../redux/UI/UIReducer";
import Product from "./Product";
import ProductSkelton from "./ProductSkeltoon";
export const SectionTitle = styled((props) => (
  <Typography {...props} variant={"h5"}>
    {props.children}
  </Typography>
))(({ theme }) => ({
  fontFamily: "Montserrat, sans-serif",
  letterSpacing: 3,
  textTransform: "uppercase",
  textAlign: "center",
  [theme.breakpoints.up("lg")]: {
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.down("lg")]: {
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.down("md")]: {
    marginBottom: theme.spacing(1),
  },
  [theme.breakpoints.down("sm")]: {
    marginBottom: theme.spacing(1),
  },
}));

export const StyledButton = styled((props) => (
  <Button {...props}>{props.children}</Button>
))(({ theme }) => ({
  textTransform: "capitalize",
  background: "#b59677",
  color: "white",
  width: "10rem",
  height: "3rem",
  margin: "auto",
  borderRadius: 0,
  marginTop: theme.spacing(4),
  fontSize: theme.typography.body1.fontSize,
  transform: "translateX(0)",
  "& svg": {
    transition: "0.4s",
  },
  "&:hover": {
    background: "#c9a785",
    "& svg": {
      transform: "translateX(10px)",
    },
  },
}));

const LatestProducts = () => {
  const productsQuery = useGetLimitProductsQuery(3);
  //   const products = [
  //     {
  //       img1: prod1,
  //       img2: prod1_2,
  //       title: "blue cotton leggings",
  //       oldPrice: 50.0,
  //       newPrice: 30.0,
  //       colors: ["green", "white", "blue"],
  //       link: "",
  //       sale: "",
  //     },
  //     {
  //       img1: prod1,
  //       img2: prod1_2,
  //       title: "blue cotton leggings",
  //       oldPrice: "",
  //       newPrice: 30.0,
  //       colors: ["green", "white", "blue"],
  //       link: "",
  //       sale: "",
  //     },
  //     {
  //       img1: prod1,
  //       img2: prod1_2,
  //       title: "blue cotton leggings",
  //       oldPrice: "",
  //       newPrice: "30,00$",
  //       colors: ["green", "white", "blue"],
  //       link: "",
  //       sale: "",
  //     },
  //   ];
  return (
    <Container
      sx={{
        my: { lg: 8, md: 6, sm: 4, xs: 4 },
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SectionTitle>latest products</SectionTitle>
      <Box
        sx={{
          display: "grid",
          flexDirection: { xs: "row" },
          gap: 2,
          flexWrap: "wrap",
          justifyContent: "start",
          width: "100%",
          gridTemplateColumns: {
            sm: "repeat(1, minmax(0, 1fr))",
            md: "repeat(2, minmax(0, 2fr))",
            lg: "repeat(3, minmax(0, 3fr))",
          },
        }}
        className="grid-cols-1"
      >
        {productsQuery.isLoading && <ProductSkelton />}
        {productsQuery.isError && (
          <h4 style={{ textAlign: "center", width: "100%" }}>
            something wrong happened...try again!
          </h4>
        )}
        {productsQuery.isSuccess &&
          productsQuery.data.data.map((prod, index) => (
            <Product
              id={prod.id}
              productDisplayprop={ChangeProductGridDisplay}
              key={index}
              img1={prod.image}
              img2={prod.image}
              title={prod.title}
              oldPrice={prod.price - (prod.price * 10) / 100}
              newPrice={prod.price}
              colors={["green", "white", "blue"]}
              link={prod.link}
              sale={prod.sale}
              details={prod.details}
            />
          ))}
      </Box>
      <StyledButton>
        load more <SouthIcon fontSize="5px" sx={{ marginLeft: 1 }} />
      </StyledButton>
    </Container>
  );
};

export default LatestProducts;
